import partsVickers from "../utils/parts-vickers.json";
import partsCharlynn from "../utils/parts-charlynn.json";
import partsRexroth from "../utils/parts-rexroth.json";
import partsRacine from "../utils/parts-racine.json";
import partsParker from "../utils/parts-parker.json";
import partsDenison from "../utils/parts-denison.json";

export const INVENTORY_OVERVIEW = {
	en: {
		pageTitle:
			"TU - Technical Union | Industrial exporters, hydraulics, pneumatics, electrical, mechanical products.",
		metaDescription: "Product categories for hydraulic, mechanical, electrical and more.",
		metaKeywords: "tu, hydraulics, valves, motors, pumps",
		ogTitle:
			"TU | Industrial exporters, hydraulics, pneumatics, electrical, mechanical products",
		ogDescription: "Product categories for hydraulic, mechanical, electrical and more.",
		ogUrl: "https://www.tu.biz/en/inventory",
		twitterTitle:
			"TU | Industrial exporters, hydraulics, pneumatics, electrical, mechanical products",
		twitterDescription:
			"Product categories for hydraulic, mechanical, electrical and more.",
		title: "Inventory",
		introLead: "Here is a quick overview of regular components coming from our inventory.",
		introMiddle: "If you have any requirements on these components you can always",
		contactUs: "contact us",
		introTrail: "for a quote request.",
		contactHref: "/en/contact-us",
		brandsHeading: "Browse by brand",
		brandsSubtitle:
			"Select a manufacturer to view alternative replacement part numbers.",
	},
	es: {
		pageTitle:
			"TU - Technical Union | Exportadores industriales, hidráulica, neumática, eléctrico, productos mecánicos.",
		metaDescription: "Categorías de productos hidráulicos, mecánicos, eléctricos y más.",
		metaKeywords: "tu, hidráulica, válvulas, motores, bombas",
		ogTitle:
			"TU | Exportadores industriales, hidráulica, neumática, eléctrico, productos mecánicos",
		ogDescription: "Categorías de productos hidráulicos, mecánicos, eléctricos y más.",
		ogUrl: "https://www.tu.biz/es/inventario",
		twitterTitle:
			"TU | Exportadores industriales, hidráulica, neumática, eléctrico, productos mecánicos",
		twitterDescription:
			"Categorías de productos hidráulicos, mecánicos, eléctricos y más.",
		title: "Inventario",
		introLead:
			"Aquí tiene un resumen rápido de los componentes habituales disponibles en nuestro inventario.",
		introMiddle: "Si tiene necesidades relacionadas con estos componentes, puede",
		contactUs: "contactarnos",
		introTrail: "para solicitar una cotización.",
		contactHref: "/es/contactenos",
		brandsHeading: "Buscar por marca",
		brandsSubtitle:
			"Seleccione un fabricante para ver números de pieza de recambio alternativos.",
	},
};

const SHARED = {
	en: {
		contactUs: "contact us",
		tableReference: "Reference",
		tableDescription: "Description",
		tableReplacement: "Replacement",
		searchPlaceholder: "Search by part number…",
		searchTitle: "Search parts",
		backToInventory: "All inventory brands",
		resultsLabel: (n) => `${n} part${n === 1 ? "" : "s"}`,
		emptyResults: "No parts match your search.",
	},
	es: {
		contactUs: "contactarnos",
		tableReference: "Referencia",
		tableDescription: "Descripción",
		tableReplacement: "Reemplazo",
		searchPlaceholder: "Buscar por número de pieza…",
		searchTitle: "Buscar piezas",
		backToInventory: "Todas las marcas de inventario",
		resultsLabel: (n) => `${n} pieza${n === 1 ? "" : "s"}`,
		emptyResults: "Ninguna pieza coincide con su búsqueda.",
	},
};

export const INVENTORY_BRANDS = [
	{
		key: "eaton-vickers",
		enSlug: "vickers",
		esSlug: "eaton-vickers",
		label: "Eaton-Vickers",
		db: partsVickers,
		pageSize: 30,
		en: {
			pageTitle: "TU - Technical Union | Alternative Vickers hydraulic parts",
			metaDescription:
				"View our inventory to replace Eaton-Vickers hydraulic parts. Quick delivery.",
			metaKeywords: "tu, inventory, hydraulics, eaton, vickers",
			ogTitle: "Inventory of alternative components to replace Vickers hydraulics",
			ogDescription:
				"View our inventory parts to replace Eaton-Vickers components. Quick delivery.",
			ogImage: "https://www.tu.biz/oppictures/vickers-replacement.png",
			ogUrl: "https://www.tu.biz/en/inventory/vickers",
			twitterTitle: "TU | Eaton Vickers replacement parts",
			twitterDescription:
				"Check out our inventory to replace Eaton Vickers hydraulic components.",
			heading: "Eaton-Vickers replacements",
			introLead:
				"Here is a quick overview of regular components from our inventory to replace Eaton-Vickers parts such as hydraulic valves and pumps.",
			introMiddle: "If you have any requirements on these components you can always",
			introTrail: "for a quote request.",
		},
		es: {
			pageTitle: "TU - Technical Union | Piezas hidráulicas alternativas Eaton-Vickers",
			metaDescription:
				"Vista de nuestro inventario para sustituir piezas hidráulicas Eaton-Vickers. Entrega rápida.",
			metaKeywords: "tu, inventario, hidráulica, eaton, vickers",
			ogTitle: "Inventario de componentes alternativos para hidráulica Vickers",
			ogDescription:
				"Piezas de inventario para sustituir componentes Eaton-Vickers. Entrega rápida.",
			ogImage: "https://www.tu.biz/oppictures/vickers-replacement.png",
			ogUrl: "https://www.tu.biz/es/inventario/eaton-vickers",
			twitterTitle: "TU | Piezas de recambio Eaton Vickers",
			twitterDescription:
				"Consulte nuestro inventario para sustituir componentes hidráulicos Eaton Vickers.",
			heading: "Recambios Eaton-Vickers",
			introLead:
				"Resumen de los componentes habituales de nuestro inventario para sustituir piezas Eaton-Vickers, como válvulas y bombas hidráulicas.",
			introMiddle: "Si tiene necesidades relacionadas con estos componentes, puede",
			introTrail: "para solicitar una cotización.",
		},
	},
	{
		key: "eaton-charlynn",
		enSlug: "charlynn",
		esSlug: "eaton-charlynn",
		label: "Eaton-Charlynn",
		db: partsCharlynn,
		pageSize: 30,
		en: {
			pageTitle: "TU - Technical Union | Hydraulic inventory to replace Eaton-Charlynn",
			metaDescription:
				"Large inventory of hydraulic components to replace Eaton Charlynn hydraulic motors.",
			metaKeywords: "tu, inventory, Eaton, Char-Lynn",
			ogTitle: "Replacements for Eaton Charlynn hydraulic motors",
			ogDescription: "Large inventory to replace Eaton Charlynn hydraulic motors.",
			ogImage: "https://www.tu.biz/oppictures/charlynn-replacement.png",
			ogUrl: "https://www.tu.biz/en/inventory/charlynn",
			twitterTitle: "TU | Charlynn replacement motors",
			twitterDescription: "View hydraulic motors to replace Eaton Charlynn units.",
			heading: "Eaton-Charlynn replacements",
			introLead:
				"Overview of regular components from our inventory to replace Eaton Charlynn hydraulic motor units.",
			introMiddle: "If you have any requirements on these components you can always",
			introTrail: "for a quote request.",
		},
		es: {
			pageTitle: "TU - Technical Union | Inventario hidráulico para sustituir Eaton-Charlynn",
			metaDescription:
				"Amplio inventario de componentes hidráulicos para sustituir motores hidráulicos Eaton Charlynn.",
			metaKeywords: "tu, inventario, Eaton, Char-Lynn",
			ogTitle: "Recambios para motores hidráulicos Eaton Charlynn",
			ogDescription: "Gran inventario para sustituir motores hidráulicos Eaton Charlynn.",
			ogImage: "https://www.tu.biz/oppictures/charlynn-replacement.png",
			ogUrl: "https://www.tu.biz/es/inventario/eaton-charlynn",
			twitterTitle: "TU | Motores de recambio Charlynn",
			twitterDescription: "Vista de motores hidráulicos para sustituir unidades Eaton Charlynn.",
			heading: "Recambios Eaton-Charlynn",
			introLead:
				"Resumen de los componentes habituales de nuestro inventario para sustituir los grupos de motores hidráulicos Eaton Charlynn.",
			introMiddle: "Si tiene necesidades relacionadas con estos componentes, puede",
			introTrail: "para solicitar una cotización.",
		},
	},
	{
		key: "bosch-rexroth",
		enSlug: "rexroth",
		esSlug: "bosch-rexroth",
		label: "Bosch-Rexroth",
		db: partsRexroth,
		pageSize: 30,
		en: {
			pageTitle: "TU - Technical Union | Rexroth replacement components",
			metaDescription: "Inventory for Bosch Rexroth replacements. Quick part delivery.",
			metaKeywords: "tu, inventory, hydraulics, rexroth",
			ogTitle: "Rexroth hydraulic replacement components",
			ogDescription:
				"Inventory of alternative Rexroth hydraulic components, pumps and valves.",
			ogImage: "https://www.tu.biz/oppictures/rexroth-replacement.png",
			ogUrl: "https://www.tu.biz/en/inventory/rexroth",
			twitterTitle: "TU | Rexroth replacement parts inventory",
			twitterDescription: "Large inventory of alternative Rexroth hydraulic components.",
			heading: "Bosch-Rexroth replacements",
			introLead:
				"Overview of regular components from our inventory to replace Bosch Rexroth hydraulic components.",
			introMiddle: "If you have any requirements on these components you can always",
			introTrail: "for a quote request.",
		},
		es: {
			pageTitle: "TU - Technical Union | Componentes de recambio Bosch Rexroth",
			metaDescription: "Inventario para recambios Bosch Rexroth. Entrega rápida de piezas.",
			metaKeywords: "tu, inventario, hidráulica, rexroth",
			ogTitle: "Componentes de recambio hidráulicos Rexroth",
			ogDescription:
				"Inventario de componentes hidráulicos alternativos Rexroth, bombas y válvulas.",
			ogImage: "https://www.tu.biz/oppictures/rexroth-replacement.png",
			ogUrl: "https://www.tu.biz/es/inventario/bosch-rexroth",
			twitterTitle: "TU | Inventario de piezas de recambio Rexroth",
			twitterDescription: "Amplio inventario de componentes hidráulicos alternativos Rexroth.",
			heading: "Recambios Bosch-Rexroth",
			introLead:
				"Resumen de los componentes habituales de nuestro inventario para sustituir componentes hidráulicos Bosch Rexroth.",
			introMiddle: "Si tiene necesidades relacionadas con estos componentes, puede",
			introTrail: "para solicitar una cotización.",
		},
	},
	{
		key: "bosch-racine",
		enSlug: "racine",
		esSlug: "bosch-racine",
		label: "Bosch-Racine",
		db: partsRacine,
		pageSize: 30,
		en: {
			pageTitle: "TU - Technical Union | Racine hydraulic parts inventory",
			metaDescription: "Inventory to replace Racine hydraulic parts. Quick delivery.",
			metaKeywords: "tu, inventory, hydraulics, racine",
			ogTitle: "Racine hydraulic replacement components",
			ogDescription: "Large inventory to replace Racine hydraulic parts.",
			ogImage: "https://www.tu.biz/oppictures/racine-replacement.png",
			ogUrl: "https://www.tu.biz/en/inventory/racine",
			twitterTitle: "TU | Racine hydraulic replacements",
			twitterDescription: "Large inventory to replace Racine hydraulic components.",
			heading: "Bosch-Racine replacements",
			introLead:
				"Overview of regular components from our inventory to replace Racine hydraulic components.",
			introMiddle: "If you have any requirements on these components you can always",
			introTrail: "for a quote request.",
		},
		es: {
			pageTitle: "TU - Technical Union | Inventario de piezas hidráulicas Racine",
			metaDescription:
				"Inventario para sustituir piezas hidráulicas Racine. Entrega rápida de componentes.",
			metaKeywords: "tu, inventario, hidráulica, racine",
			ogTitle: "Componentes de recambio hidráulicos Racine",
			ogDescription: "Amplio inventario para sustituir piezas hidráulicas Racine.",
			ogImage: "https://www.tu.biz/oppictures/racine-replacement.png",
			ogUrl: "https://www.tu.biz/es/inventario/bosch-racine",
			twitterTitle: "TU | Recambios hidráulicos Racine",
			twitterDescription:
				"Amplio inventario para sustituir componentes hidráulicos Racine.",
			heading: "Recambios Bosch-Racine",
			introLead:
				"Resumen de los componentes habituales de nuestro inventario para sustituir componentes hidráulicos Racine.",
			introMiddle: "Si tiene necesidades relacionadas con estos componentes, puede",
			introTrail: "para solicitar una cotización.",
		},
	},
	{
		key: "parker",
		enSlug: "parker",
		esSlug: "parker",
		label: "Parker",
		db: partsParker,
		pageSize: 10,
		en: {
			pageTitle: "TU - Technical Union | Parker hydraulic replacements",
			metaDescription:
				"View Parker hydraulic replacement inventory at TU Technical Union. In-stock products.",
			metaKeywords: "tu, inventory, hydraulics, parker",
			ogTitle: "Parker hydraulic replacement components",
			ogDescription:
				"View inventory of Parker hydraulic alternatives. In stock for quick delivery.",
			ogImage: "https://www.tu.biz/oppictures/parker-replacements.png",
			ogUrl: "https://www.tu.biz/en/inventory/parker",
			twitterTitle: "TU | Parker hydraulic replacement components",
			twitterDescription: "Inventory of alternatives to replace Parker hydraulic parts.",
			heading: "Parker replacements",
			introLead:
				"Overview of regular components from our inventory to replace Parker hydraulic components.",
			introMiddle: "If you have any requirements on these components you can always",
			introTrail: "for a quote request.",
		},
		es: {
			pageTitle: "TU - Technical Union | Recambios hidráulicos Parker",
			metaDescription:
				"Vista del inventario de componentes de recambio hidráulicos Parker en TU Technical Union.",
			metaKeywords: "tu, inventario, hidráulica, parker",
			ogTitle: "Componentes de recambio hidráulicos Parker",
			ogDescription:
				"Vista de inventario de alternativas para hidráulica Parker. Todo en stock para entrega rápida.",
			ogImage: "https://www.tu.biz/oppictures/parker-replacements.png",
			ogUrl: "https://www.tu.biz/es/inventario/parker",
			twitterTitle: "TU | Componentes de recambio hidráulicos Parker",
			twitterDescription:
				"Inventario de componentes alternativos para sustituir piezas hidráulicas Parker.",
			heading: "Recambios Parker",
			introLead:
				"Resumen de los componentes habituales de nuestro inventario para sustituir componentes hidráulicos Parker.",
			introMiddle: "Si tiene necesidades relacionadas con estos componentes, puede",
			introTrail: "para solicitar una cotización.",
		},
	},
	{
		key: "parker-denison",
		enSlug: "denison",
		esSlug: "parker-denison",
		label: "Parker Denison",
		db: partsDenison,
		pageSize: 30,
		en: {
			pageTitle: "TU - Technical Union | Denison hydraulic replacements",
			metaDescription: "Inventory to replace Denison hydraulic components.",
			metaKeywords: "tu, Denison, inventory, replacements",
			ogTitle: "Replacements for Denison hydraulics",
			ogDescription: "View our inventory to replace Denison hydraulic components.",
			ogImage: "https://www.tu.biz/oppictures/denison-replacement.png",
			ogUrl: "https://www.tu.biz/en/inventory/denison",
			twitterTitle: "TU | Denison hydraulic replacements",
			twitterDescription: "Inventory to replace Denison hydraulic components.",
			heading: "Parker Denison replacements",
			introLead:
				"Overview of regular components from our inventory to replace Denison hydraulic components.",
			introMiddle: "If you have any requirements on these components you can always",
			introTrail: "for a quote request.",
		},
		es: {
			pageTitle: "TU - Technical Union | Recambios hidráulicos Denison",
			metaDescription: "Inventario para sustituir componentes hidráulicos Denison.",
			metaKeywords: "tu, Denison, inventario, recambios",
			ogTitle: "Recambios para hidráulica Denison",
			ogDescription: "Vista de nuestro inventario para sustituir componentes hidráulicos Denison.",
			ogImage: "https://www.tu.biz/oppictures/denison-replacement.png",
			ogUrl: "https://www.tu.biz/es/inventario/parker-denison",
			twitterTitle: "TU | Recambios hidráulicos Denison",
			twitterDescription: "Inventario para sustituir componentes hidráulicos Denison.",
			heading: "Recambios Parker Denison",
			introLead:
				"Resumen de los componentes habituales de nuestro inventario para sustituir componentes hidráulicos Denison.",
			introMiddle: "Si tiene necesidades relacionadas con estos componentes, puede",
			introTrail: "para solicitar una cotización.",
		},
	},
];

export function getInventoryShared(locale) {
	return SHARED[locale] || SHARED.en;
}

export function getBrandBySlug(locale, slug) {
	return INVENTORY_BRANDS.find((b) =>
		locale === "es" ? b.esSlug === slug : b.enSlug === slug
	);
}

export function getBrandHref(brand, locale) {
	return locale === "es"
		? `/es/inventario/${brand.esSlug}`
		: `/en/inventory/${brand.enSlug}`;
}

export const ES_INVENTORY_BRAND_SLUGS = INVENTORY_BRANDS.map((b) => b.esSlug);

export const ES_SLUG_TO_DB = Object.fromEntries(
	INVENTORY_BRANDS.map((b) => [b.esSlug, b.db])
);

export function getPageSizeForEsInventorySlug(slug) {
	return getBrandBySlug("es", slug)?.pageSize ?? 30;
}
